import { render } from "./shoppingCartModel.vue?vue&type=template&id=59cdb0b6"
import script from "./shoppingCartModel.vue?vue&type=script&lang=js"
export * from "./shoppingCartModel.vue?vue&type=script&lang=js"

import "./shoppingCartModel.vue?vue&type=style&index=0&id=59cdb0b6&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__